import React, { useEffect, useState } from 'react';

// Local replacement for react-search-field 2.0.1, which is unmaintained and
// pins React 16 as a peer. Same DOM, class names and inline styles, so the
// .react-search-field overrides in OrdersView keep applying.
export interface SearchFieldProps {
  placeholder?: string;
  searchText?: string;
  onChange?: (value: string) => any;
  onEnter?: (value: string) => any;
  onSearchClick?: (value: string) => any;
}

const SearchField = ({
  placeholder = 'Search',
  searchText = '',
  onChange,
  onEnter,
  onSearchClick,
}: SearchFieldProps) => {
  const [value, setValue] = useState(searchText);

  useEffect(() => {
    setValue(searchText);
  }, [searchText]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onEnter) {
      onEnter(event.currentTarget.value);
    }
  };

  const handleSearchClick = () => {
    if (onSearchClick) {
      onSearchClick(value);
    }
  };

  return (
    <div className="react-search-field" style={containerStyle}>
      <input
        className="react-search-field-input"
        style={inputStyle}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        type="text"
        value={value}
      />
      <button
        className="react-search-field-button"
        type="button"
        aria-label="search button"
        style={buttonStyle}
        onClick={handleSearchClick}
      >
        <SearchIcon />
      </button>
    </div>
  );
};

const SearchIcon = () => (
  <svg version="1.1" x="0px" y="0px" width={21} height={21} viewBox="0 0 635 635" style={{ fill: '#727272' }}>
    <g>
      <path d="M255.108,0C119.863,0,10.204,109.66,10.204,244.904c0,135.245,109.659,244.905,244.904,244.905 c52.006,0,100.238-16.223,139.883-43.854l185.205,185.176c1.671,1.672,4.379,1.672,5.964,0.115l34.892-34.891 c1.613-1.613,1.47-4.379-0.115-5.965L438.151,407.605c38.493-43.246,61.86-100.237,61.86-162.702 C500.012,109.66,390.353,0,255.108,0z M255.108,460.996c-119.34,0-216.092-96.752-216.092-216.092 c0-119.34,96.751-216.091,216.092-216.091s216.091,96.751,216.091,216.091C471.199,364.244,374.448,460.996,255.108,460.996z" />
    </g>
  </svg>
);

const containerStyle: React.CSSProperties = {
  border: '1px #ddd solid',
  display: 'inline-flex',
  justifyContent: 'space-between',
  height: 35,
};

const inputStyle: React.CSSProperties = {
  outline: 'none',
  border: 'none',
  fontSize: 14,
  padding: '0 8px',
  flex: 1,
  color: '#5a5a5a',
  fontWeight: 100,
  height: 33,
};

const buttonStyle: React.CSSProperties = {
  height: 33,
  width: 33,
  outline: 'none',
  backgroundColor: 'white',
  cursor: 'pointer',
  padding: 5,
  boxSizing: 'border-box',
  appearance: 'none',
  border: 'none',
  borderLeft: '1px #ddd solid',
};

export default SearchField;
